import { SimpleObservable } from "../../services/SimpleObservable";

export interface BottomSheetType {
  id: number;
  component: JSX.Element;
  config?: BottomSheetConfig;
}

export type BottomSheetConfig = {
  noClose?: boolean;
  height?: string;
  fullScreen?: boolean;
};

export class BottomSheetService extends SimpleObservable {
  private nextId = 0;
  private bottomSheet!: BottomSheetType;
  private activeBottomSheets = new Set<number>();

  public getBottomSheet(): BottomSheetType {
    return this.bottomSheet;
  }

  public hasBottomSheet() {
    return this.activeBottomSheets.size > 0;
  }

  public nameIs(name: string) {
    return this.hasBottomSheet() && this.bottomSheet?.component?.type?.name === name;
  }

  public showBottomSheet(component: JSX.Element, config?: BottomSheetConfig): Promise<number> {
    return new Promise((resolve) => {
      const id = this.nextId++;
      this.bottomSheet = {
        id,
        component,
        config: {
          height: "50vh",
          fullScreen: false,
          ...config,
        },
      };
      this.activeBottomSheets.add(id);
      this.inform({ type: "show", data: null });
      resolve(id);
    });
  }

  public popBottomSheet(id?: number): void {
    const bottomSheetId = id ?? this.bottomSheet?.id;
    if (bottomSheetId !== undefined) {
      this.activeBottomSheets.delete(bottomSheetId);
    }
    this.inform({ type: "hide", data: bottomSheetId });
  }

  public popAll(): void {
    const idsToClose = Array.from(this.activeBottomSheets);
    this.activeBottomSheets.clear();
    idsToClose.forEach((id) => {
      this.inform({ type: "hide", data: id });
    });
  }
}

export const bottomSheetService = new BottomSheetService();
